


export const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer  className="h-207.5 flex items-center justify-center footer-gradient absolute bottom-0 w-screen">
      <a href="mailto:hello@avela.studio" className="font-magic  sm:text-[96px] px-8 text-h1-mobile hover:text-white-main/65 transition-colors duration-200 ease-in-out">hello@avela.studio</a>
      <p id="contact" className="absolute bottom-6 font-medium left-1/2 transform -translate-x-1/2 text-blue-main">{`©avelastudio ${year}`}</p>
    </footer>
  )
}